"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStepLabelMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Tag = require("../../components/Tag/Tag.styles");
var ProgressStepperStepLabelMixin = function ProgressStepperStepLabelMixin(props) {
  var active = props.active,
    appearance = props.appearance,
    alignLabel = props.alignLabel;
  return (0, _styledToken.default)({
    interactiveStepSize: 'ProgressStepper.interactiveStepSize',
    labelOffset: 'ProgressStepper.labelOffset',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize',
    tagMarginTop: 'ProgressStepper.tagMarginTop'
  }, function (_ref) {
    var interactiveStepSize = _ref.interactiveStepSize,
      labelOffset = _ref.labelOffset,
      nonInteractiveStepSize = _ref.nonInteractiveStepSize,
      tagMarginTop = _ref.tagMarginTop;
    return (0, _styledComponents.css)(["margin-top:", "px;text-align:", ";word-break:break-all;", "{margin-top:", "px;}"], appearance || active ? labelOffset : labelOffset + (interactiveStepSize - nonInteractiveStepSize) / 2, alignLabel, _Tag.StyledTag, tagMarginTop);
  })(props);
};
exports.ProgressStepperStepLabelMixin = ProgressStepperStepLabelMixin;